import Sha256 from 'js-sha256';
import Cookies from 'universal-cookie'

export const HandleTextChange = function handleTextChange(event, path) {
    const target = event.target;
    //console.log("storing... " + target.value + " into " + target.name)
    storeData(target.value, target.name, this, path);
}

export const HandlePassChange = function handlePassChange(event, component) {
    const target = event.target;
    const value = Sha256.sha256(target.value);
    component.setState({[target.name]: value});
}

export const HandleSignatureChange = function handleSignatureChange(event, component) {
    storeData(new Date().toISOString(), "SignatureTime", component)
}

export const HandleCheckChange = function handleCheckChange(event, path) {
    const target = event.target;
    storeData(target.checked, target.name, this, path);
}

export const HandleSelectChange = function handleSelectChange(event, path) {
    const target = event.target;
    storeData(target.value, target.name, this, path)
}

export const Check = (event, component) => {
    const target = event.target;
    if (Sha256.sha256(target.value) !== component.state.pass) {
        target.setCustomValidity('Password must be matching.');
    } else {
        target.setCustomValidity('');
    }
}

export const RadioHandler = function radioHandler (event, path) {
    const target = event.target;
    // Use the input's `name` attribute directly. Previously this derived the
    // field name by stripping the last character of `id` (e.g. "Skin1" -> "Skin"),
    // which broke for radio groups with 10+ options (e.g. "Skin10" -> "Skin1"),
    // sending the value to the wrong state key and causing DB enum truncation.
    const name = target.name;
    storeData(target.value, name, this, path);
}

export const GetValues = (component, id, name, callback) => {
    var message = {"Patient_ID": id};
    CallAPI(message, name+'Fill', component, (res) => {
        component.setState(res.message, callback);
    });
}
 
export const CallAPI = (reqBody, api, httpMethod, successCallback, errorCallback = null) => {
    //console.log(reqBody);
    // Add signed-in user's ID to the body. TODO: Remove
    reqBody.id = GetCookieFunction("User").id;
    //reqBody.token = GetCookieFunction("User").token;
    const message = JSON.stringify(reqBody);
    var url = `${window._env_.REACT_APP_API_HOST}/${api}`;
    
    console.log("Attempting to call api " + api + " at " + url);

    const requestOptions = (httpMethod === "GET") ? {
        method: httpMethod,
        headers: { 'Content-Type': 'application/json' }
    } : {
        method: httpMethod,
        headers: { 'Content-Type': 'application/json' },
        body: message
    }

    // Add verification information to API Calls
    // TODO: Convert to JWT
    requestOptions.headers['x-user-id'] = GetCookieFunction("User").id;
    requestOptions.headers['x-user-token'] = GetCookieFunction("User").token;

    fetch(url, requestOptions).then(
        async response => {
            const data = await response.json();

            if (!response.ok) {
                const error = data || response.status;
                throw error;
            }

            if(successCallback) {
                successCallback(data)
            }

            return data;
        }
    ).catch(error => {
        console.error(`API Returned: ${JSON.stringify(error)}`);

        // Error message format: {"success":bool,"message":string,"data":[]}
        if (errorCallback) {
            errorCallback(error);
        }
    });
}

const storeData = (value, name, component, path) => {
    if(!path) {
        component.setState({[name]: value});
    }
    else {
        component.setState((state) => {
            return ({[path]: {...state[path], [name]: value}});
        });
    };
};

export const SetCookieFunction = (target) => {
    const cookies = new Cookies();
    let expiry_date = new Date();
    let exp_minutes = 180; // 3 hours
    expiry_date.setTime(expiry_date.getTime() + (exp_minutes*60*1000));
    cookies.set(target.name, target.value, {path: "/", expires: expiry_date});
}

export const GetCookieFunction = (name) => {
    const cookies = new Cookies();
    const stored = cookies.get(name);
    if(stored == null) {
        return "";
    }
    else {
        return stored;
    }
}

// e.g. GetTzAwareTime("2022-12-01T08:00:00.000Z", "Asia/Dhaka")
export const GetTzAwareTime = (sUtcTimeWithTz, sTimeZone, timeOnly=false) => {
    let format = {
        hour:   'numeric',
        minute: 'numeric',
        timeZone: sTimeZone,
    };
    if(!timeOnly) {
        format.day = 'numeric';
        format.month = 'short';
        format.year = 'numeric';
    }
    /*return (new Date(sUtcTimeWithTz)).toLocaleString(undefined, {
        day:    'numeric',
        month:  'short',
        year:   'numeric',
        hour:   'numeric',
        minute: 'numeric',
        timeZone: sTimeZone,
    });*/
    return (new Date(sUtcTimeWithTz)).toLocaleString(undefined, format);
}

export const RemoveCookieFunction = (name) => {
    const cookies = new Cookies();
    cookies.remove(name);
}

export const RemoveAllCookies = () => {
    const cookies = new Cookies()
    const cookieList = cookies.getAll()
    for (const cookie in cookieList) {
        cookies.remove(cookie)
    }
}

// Return converted integer, or 0 if invalid int
export const parseIntFromStr = (strVal) => {
    var intVal = parseInt(strVal ?? "0") 
    return isNaN(intVal) ? 0 : intVal;
}

export const CapitalizeWord = (word) => {
    if (word) {
        return (word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
    } 
    return "";
}

// Removes all HTML tags for security, replaces newlines with <BR/>
export const PrepTextForDisplay = (str) => {
    // Remove all HTML tags first
    str = str.replace(/<[^>]*>/g, "");
    return (str.replace(/\n/g, "<br />"));
}

// --- Age <-> Date of Birth helpers (patient records) ---
// Patients are entered/edited by age only; we store a Date of Birth under the
// hood. We anchor the derived DOB to January 1 of the birth year so the value
// is stable and locale-independent. Age is always whole years.

// Convert a whole-year age to a "yyyy-01-01" birthday string anchored to Jan 1.
// Returns "" for invalid/empty input.
export const AgeToBirthday = (age) => {
    const years = parseInt(age, 10);
    if (isNaN(years) || years < 0 || years > 150) {
        return "";
    }
    const birthYear = new Date().getFullYear() - years;
    return `${birthYear}-01-01`;
};

// Convert a stored birthday into a whole-year age using (currentYear - birthYear).
// Accepts a Date, an ISO / "yyyy-mm-dd" string, or the API's "d-m-yyyy" string
// (returned by /basic and /lookup). Returns `fallback` if the birthday is missing
// or unparseable. An age of 0 is returned as 0, not treated as missing.
export const BirthdayToAge = (bDay, fallback = "") => {
    if (!bDay) {
        return fallback;
    }
    let birthYear;
    if (bDay instanceof Date) {
        birthYear = bDay.getUTCFullYear();
    } else {
        const str = String(bDay);
        // Year is either the leading 4 digits (yyyy-mm-dd / ISO) or the trailing 4 digits (d-m-yyyy).
        const match = str.match(/^(\d{4})-/) || str.match(/-(\d{4})$/);
        if (!match) {
            return fallback;
        }
        birthYear = parseInt(match[1], 10);
    }
    if (isNaN(birthYear)) {
        return fallback;
    }
    return new Date().getFullYear() - birthYear;
};
